import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import TextBlock from './TextBlock';

import './ImageTextBlock.scss';

const ImageTextBlock = ({
  imagePosition,
  imageSrc,
  imageDescription,
  imageStyle,
  titleTag,
  title,
  content,
  alignTo,
  titleSize,
  contentSize,
  textStyle
}) => {
  const containerClass = classNames('image-text-block', {
    'image-text-block--left-image': imagePosition === 'left'
  });

  const textClass = classNames(
    'image-text-block__text',
    'image-text-block__side',
    {
      'image-text-block__text--left-image': imagePosition === 'left'
    }
  );

  const imageContainerClass = classNames('image-text-block__side', {
    'image-text-block__side--left-image': imagePosition === 'left'
  });

  const imageClass = classNames('image-text-block__image');

  return (
    <div className={containerClass}>
      <div className={textClass}>
        <TextBlock
          title={title}
          content={content}
          alignTo={alignTo}
          titleSize={titleSize}
          titleTag={titleTag}
          contentSize={contentSize}
          style={textStyle}
        />
      </div>
      <div className={imageContainerClass}>
        <img
          className={imageClass}
          src={imageSrc}
          alt={imageDescription}
          style={imageStyle}
        />
      </div>
    </div>
  );
};

ImageTextBlock.propTypes = {
  imagePosition: PropTypes.oneOf(['left', 'right']),
  imageSrc: PropTypes.string.isRequired,
  imageDescription: PropTypes.string.isRequired,
  imageStyle: PropTypes.string,
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  alignTo: PropTypes.oneOf(['right', 'left', 'center']),
  titleSize: PropTypes.oneOf(['big', 'medium']),
  titleTag: PropTypes.string,
  contentSize: PropTypes.oneOf(['big', 'medium']),
  textStyle: PropTypes.string
};

ImageTextBlock.defaultProps = {
  imagePosition: 'right',
  imageStyle: {},
  titleTag: 'h2',
  alignTo: 'center',
  titleSize: 'big',
  contentSize: 'medium',
  textStyle: {}
};

export default ImageTextBlock;
